<div class="dialog-header">
  <h2 mat-dialog-title>Aggiunta rapida</h2>
  <!-- <h2 mat-dialog-title>Aggiunta rapida {{data.name}}</h2> -->
  <button
    mat-icon-button
    type="button"
    (click)="onNoClick()"
    matTooltip="Chiudi"
    class="dialog-close-btn"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
 <p
  class="ms-4 small text-muted">
  I campi contrassegnati da * sono obbligatori.
</p>

<form #CompanyForm="ngForm" (ngSubmit)="addNewCompany()" class="company-form">

<mat-dialog-content>
  
      <div class="form-container">

        <p>Inserisci i dati del cliente:</p>

        <div class="mt-2 row">      
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome Cliente</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.company_name"
              name="company_name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Tipo</mat-label>
            <mat-select
              [(ngModel)]="newCompany.type"
              name="type"
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>Type</mat-label>
            <mat-select
              [(ngModel)]="newCompany.type"
              name="type"
              required
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Codice SDI</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.addressee_code"
              name="addressee_code"
              required
              minlength="6"
              maxlength="7"
              pattern="^[A-Z0-9]*"
              #SDI_CodeInput="ngModel"
            />
            <mat-error *ngIf="SDI_CodeInput.invalid && (SDI_CodeInput.dirty || SDI_CodeInput.touched)">
              Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-100">
            <mat-label>Partita IVA</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.iva_number"
              name="iva_number"
              minlength="11"
              maxlength="11"
              pattern="[0-9]*"
              (ngModelChange)="onPartitaIvaChange($event)"
              (input)="onPartitaIvaInput($event)"
              (blur)="validatePartitaIva(newCompany.iva_number)"
              #iva_numberInput="ngModel"
            />
            <mat-error *ngIf="iva_numberInput.invalid && (iva_numberInput.dirty || iva_numberInput.touched)">
              La Partita Iva deve essere composta esattamente da 11 cifre
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Codice fiscale</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.c_f"
              name="c_f"
              maxlength="16"
              pattern="([A-Z0-9]{11}|[A-Z0-9]{16})"
              #CFInput="ngModel"
            />
            <mat-error *ngIf="CFInput.invalid && (CFInput.dirty || CFInput.touched)">
              Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
            </mat-error>
          </mat-form-field>
        </div> 
        
        <div class="row">  
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Indirizzo</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.address"
              name="address"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Città</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.city"
              name="city"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>CAP</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.cap"
              name="cap"
              required
              minlength="5"
              maxlength="5"
              pattern="[0-9]*"
              #CAP_CodeInput="ngModel"
            />
            <mat-error *ngIf="CAP_CodeInput.invalid && (CAP_CodeInput.dirty || CAP_CodeInput.touched)">
              Il CAP deve essere composto esattamente da 5 cifre
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Comune</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.comune"
              name="comune"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Provincia</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.province"
              name="province"
              required
              minlength="2"
              maxlength="2"
              pattern="[A-Z]*"
              (ngModelChange)="onProvinceChange($event)"
              (input)="onProvinceInput($event)"
              (blur)="validateProvince(newCompany.province)"
              #provinceInput="ngModel"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nazione</mat-label>
            <mat-select
              [(ngModel)]="newCompany.country"
              name="country"
              required
            >
              <mat-option *ngFor="let country of countryOptions" [value]="country.code">
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

</mat-dialog-content>

<mat-dialog-actions>
  <!-- <button matButton (click)="onNoClick()">Esci</button> -->
  <button type="button" matButton [mat-dialog-close]="company_to_register()">Esci</button>
   <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!CompanyForm.valid"
      matButton="filled"
    >
    <mat-icon>add</mat-icon>
      Aggiungi cliente
    </button>
</mat-dialog-actions>

</form>